import { lazy } from "react";
import { AppRoute } from "shared/types/AppRoute";

const CollaboratorsManagementPage = lazy(
  () => import("../pages/CollaboratorsManagementPage"),
);
const PermissionsPage = lazy(() => import("../pages/PermissionsPage"));

export const systemAdminRoutes: AppRoute[] = [
  {
    path: "/admin/collaborators",
    component: CollaboratorsManagementPage,
    domain: "system",
    requiredPermissions: ["system.users.read"],
    meta: {
      sidebar: {
        label: "Collaborators",
        iconName: "Collaborators",
      },
    },
  },
  {
    path: "/admin/permissions",
    component: PermissionsPage,
    domain: "system",
    requiredPermissionsAny: [
      "system.permissions.read",
      "system.permissions.manage",
      "system.roles.read",
      "system.roles.manage",
    ],
    meta: {
      sidebar: {
        label: "Permissions",
        iconName: "Permissions",
      },
    },
  },
];
